var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"Item","page-icon":"mdi-format-list-bulleted","collection-name":"item","done-redirect-url":"/auth/admin/item?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }